import React from 'react';
import { Header, List } from 'semantic-ui-react';
import Image from '../../../../../atoms/Image';
import { MenuConsumer } from '../../../FoodMenu.context';
import { ModifierSetsBasic } from '../modifiers';
import MenuUtil from '../../../utils/menu';
import ItemVariations from './ItemVariations';

const listItemStyle = {
  marginBottom: '1rem',
  padding: 0,
  display: 'flex',
  minHeight: 100,
  border: 'solid thin lightgray',
};

const contentStyle = {
  flexGrow: 1,
  padding: '1em',
};

const ItemHorizontalCard = ({
  id,
  name,
  description,
  image,
  gatsbyImage = {},
  imageWidth = 500,
  variations,
  onClick,
  className = '',
}) => {
  return (
    <MenuConsumer>
      {({ items, modifierSets, disableModifiers, precision }) => {
        const item = MenuUtil.getItemById(items, id);
        const { modifierSets: itemModifierSetIds } = item;
        const itemModifierSets = MenuUtil.getItemModifierSets(itemModifierSetIds, modifierSets);

        return (
          <List.Item style={listItemStyle} className={`fcfm-ihc ${className}`} onClick={onClick}>
            <div style={contentStyle}>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Header as="h5" style={{ flexGrow: 1 }}>
                  {name}
                </Header>
                <ItemVariations variations={variations} precision={precision} />
              </div>
              <p style={{ marginBottom: '0.25rem' }}>{description}</p>
              {!disableModifiers && <ModifierSetsBasic modifierSets={itemModifierSets} />}
            </div>
            {image && (
              <Image
                src={(gatsbyImage && gatsbyImage.childImageSharp) || `${image}?width=${imageWidth}`}
                className="fcfm-items-hor-image"
              />
            )}
          </List.Item>
        );
      }}
    </MenuConsumer>
  );
};

export default ItemHorizontalCard;
